import {Component, EventEmitter, Input, OnInit, Optional, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AcabimProject, AcabimProjectCreateRequest, AcabimResource, AcabimSite, ProjectApiService} from '@cas-hub/acabim-common-client';
import {NGXLogger} from 'ngx-logger';
import {MessageService} from 'primeng/api';

@Component({
    selector: 'acabim-admin-create-project',
    templateUrl: './create-project.component.html',
    styleUrls: ['./create-project.component.scss'],
    providers: [MessageService]

})
export class CreateProjectComponent implements OnInit {

    public createProjectForm: FormGroup;
    public projectGroups: AcabimResource[] = [];
    public inProgress = false;

    @Input() public site?: AcabimSite = undefined;
    @Output() public projectCreated = new EventEmitter<AcabimProject>();

    constructor(private readonly projectApiService: ProjectApiService,
                @Optional() private readonly logger?: NGXLogger) {
        this.createProjectForm = new FormGroup({
            projectName: new FormControl(null, Validators.required),
            projectGroups: new FormControl(),
            projectDescription: new FormControl()
        });
    }

    public ngOnInit(): void {
        this.projectApiService.getAllProjectGroups().subscribe(groups => this.projectGroups = groups.data);
    }

    public addProject(): void {
        if (this.createProjectForm.invalid) {
            return;
        }

        let selectedGroups: string[] = [];
        const groups = this.createProjectForm.get('projectGroups')?.value;
        if (groups) {
            selectedGroups = (groups as AcabimResource[]).map(g => g.id);
            this.logger?.debug('[CreateProjectComponent] Adding project to groups', selectedGroups);
        }

        const request: AcabimProjectCreateRequest = {
            name: this.createProjectForm.get('projectName')?.value,
            description: this.createProjectForm.get('projectDescription')?.value,
            siteId: this.site?.id,
            projectGroupIds: selectedGroups
        };

        this.inProgress = true;
        this.projectApiService.createProject(request).subscribe(p => {
            this.projectCreated.emit(p);
            this.inProgress = false;
        }, error => {
            this.logger?.error('[CreateProjectComponent] Unable to create project', error, request);
            this.inProgress = false;
        });
    }
}
